import { render } from "./FirstTimeNamedText.vue?vue&type=template&id=306b746c"
import script from "./FirstTimeNamedText.vue?vue&type=script&lang=js"
export * from "./FirstTimeNamedText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__